import { useId } from "react";
import styles from "./Loader.module.css";

// A sine wave over three periods of 80 in a 160×48 box. The group slides one period to the left in a loop,
// so the two periods in view always look the same.
const PERIOD = 80;
const WAVE = Array.from({ length: (PERIOD * 3) / 2 + 1 }, (_, i) => {
  const x = i * 2;
  const y = 24 - 14 * Math.sin((2 * Math.PI * x) / PERIOD);
  return `${i === 0 ? "M" : "L"} ${x} ${y.toFixed(2)}`;
}).join(" ");

/**
 * The journey band as a loader: the blurred coral-to-amber layer and the sharp line from JourneyBand,
 * drawn as a moving sine wave. The wave is a mask over a still gradient, so the colours stay put while it moves.
 */
const Loader = () => {
  const id = `loader-${useId().replace(/:/g, "")}`;
  const path = { d: WAVE, fill: "none", stroke: "#fff", strokeLinecap: "round" } as const;

  return (
    <svg aria-hidden='true' className={styles.loader} viewBox='0 0 160 48' width='160' height='48'>
      <defs>
        <linearGradient id={`${id}-band`} x1='0' y1='0' x2='1' y2='0'>
          <stop offset='0%' stopColor='#f08a6c' />
          <stop offset='100%' stopColor='#e8b86a' />
        </linearGradient>
        <mask id={`${id}-soft`} maskUnits='userSpaceOnUse' x='0' y='0' width='160' height='48'>
          <g className={styles.wave}>
            <path {...path} strokeWidth={5} style={{ filter: "blur(2.5px)" }} />
          </g>
        </mask>
        <mask id={`${id}-line`} maskUnits='userSpaceOnUse' x='0' y='0' width='160' height='48'>
          <g className={styles.wave}>
            <path {...path} strokeWidth={2.5} />
          </g>
        </mask>
      </defs>
      <rect data-layer='soft' width='160' height='48' fill={`url(#${id}-band)`} mask={`url(#${id}-soft)`} opacity={0.9} />
      <rect data-layer='line' width='160' height='48' fill={`url(#${id}-band)`} mask={`url(#${id}-line)`} />
    </svg>
  );
};

export default Loader;
